module.exports = __webpack_public_path__ + "images/certs-bg-alt-165c82ee6f4587aea8fa46bf29700c0e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/certs-bg-alt.jpg
 ** module id = 429
 ** module chunks = 0
 **/